import React, { useState } from "react";
import { crmAPI } from "../../../services/CreditManagerPortal/crmAPI";
import { toast } from "react-toastify";
import BankCard from "./BankCard";

const BankingConfirmationDetails = ({
  openConfirmDialog,
  application,
  distributions = [],
  error,
  loading,
  onBankSelected,
  isProcessingApproval,
  onDetailsSentSuccessfully, // New prop to pass down to BankCard
}) => {
  const normalizedDistributions = Array.isArray(distributions)
    ? distributions
    : [];

  if (loading) {
    return (
      <div className="p-4">
        <div className="mb-4">
          <h2 className="text-lg text-[#FFCA20] font-medium flex items-center gap-2">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
            Bank Confirmation Details
          </h2>
        </div>
        <div className="bg-[#1F1F1F] p-6 rounded-lg shadow-md">
          <p className="text-gray-400">Loading banking partner statuses...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="mb-4">
          <h2 className="text-lg text-[#FFCA20] font-medium flex items-center gap-2">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
            Bank Confirmation Details
          </h2>
        </div>
        <div className="bg-[#1F1F1F] p-6 rounded-lg shadow-md">
          <p className="text-red-400">
            Error loading details:{" "}
            {typeof error === "string" ? error : JSON.stringify(error)}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4 mt-2  bg-[#1e1e1e] p-2 rounded-lg shadow-md">
      <h2 className="text-lg text-[#FFCA20] font-medium flex items-center gap-2">
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 5.71094C19.1406 6.10156 19.1406 6.6875 18.75 7.03906L8.125 17.6641C7.96875 17.8594 7.73438 17.9375 7.5 17.9375C7.22656 17.9375 6.99219 17.8594 6.83594 17.6641L1.21094 12.0391C0.820312 11.6875 0.820312 11.1016 1.21094 10.7109C1.5625 10.3594 2.14844 10.3594 2.5 10.7109L7.5 15.6719L17.4609 5.71094C17.8125 5.35938 18.3984 5.35938 18.75 5.71094ZM6.83594 8.91406L3.08594 5.16406C2.69531 4.8125 2.69531 4.22656 3.08594 3.83594C3.4375 3.48438 4.02344 3.48438 4.375 3.83594L7.5 6.92188L13.7109 0.710938C14.0625 0.359375 14.6484 0.359375 15 0.710938C15.3906 1.10156 15.3906 1.6875 15 2.03906L8.125 8.91406C7.96875 9.10938 7.73438 9.1875 7.5 9.1875C7.22656 9.1875 6.99219 9.10938 6.83594 8.91406Z"
            fill="#FFCA20"
          />
        </svg>
        Bank Confirmation Details
      </h2>

      {!loading && normalizedDistributions.length === 0 ? (
        <div className="bg-[#1F1F1F] p-6 rounded-lg shadow-md">
          <p className="text-gray-400">
            No banking partner responses available yet, or loan not yet
            processed by partners.
          </p>
        </div>
      ) : (
        normalizedDistributions.map((dist, index) => (
          <BankCard
          application={application}
            openConfirmDialog={openConfirmDialog}
            key={dist._id || index}
            distribution={dist}
            isSubmitting={isProcessingApproval} // Pass down the processing state
            // handleBankApproval is now handled via openConfirmDialog -> ConfirmationDialog in parent
            onDetailsSentSuccessfully={onDetailsSentSuccessfully} // Pass down the refresh handler
            allDistributions={normalizedDistributions} // Pass all distributions for duplicate checking
          />
        ))
      )}
    </div>
  );
};

export default BankingConfirmationDetails;
